// What he's doing, in words a stranger reads without thinking.
//
// The feed chips are terse by design ("eating", "walking"). This is the other
// register: a full present-tense clause that finishes the sentence "Pino is
// ___". It's the line people screenshot, so it's written to be read out loud,
// not to be accurate about the action enum.

export const ACTION_PHRASE = {
  MOVE: 'off somewhere',
  FORAGE: 'having a bite',
  REST: 'having a sit down',
  SLEEP: 'fast asleep',
  INSPECT: 'having a good look at something',
  SOCIALISE: 'saying hello',
  WATCH: 'at the pictures',
  GAMBLE: 'trying his luck',
  BROWSE: 'down an internet rabbit hole',
  RAVE: 'dancing, badly',
  POST_TO_TWITTER: 'telling the internet something',
  SURVEY: 'staring into the middle distance',
  PADDLE: 'paddling',
  SCAVENGE: 'turning over something he found',
  TICKETS: 'looking for old tickets at the monorail station',
  DRINK: 'at the bar',
  LAUNDRY: 'watching the laundry go round',
  MUSEUM: 'at the museum',
  PREEN: 'having his feathers done',
  TATTOO: 'watching the needle through the glass',
  PHONE: 'on the payphone',
  JUDGE: 'looking at something someone left him',
  STUDIO: 'in the studio, making something',
  // the server's own line (npc.now) names which place; this is the fallback
  GRANTED: 'somewhere he asked for',
  IDLE: 'having a think',
}

/** The clause for an action, or a sane fallback for anything unmapped. */
export function phraseFor(action) {
  if (!action) return null
  return ACTION_PHRASE[action] || String(action).toLowerCase().replace(/_/g, ' ')
}
